<style lang="scss" scoped>
header {
    &.scrollup {
        transform: translateY(-36px);

        .usp-bar {
            .row {
                > div {
                    opacity: 0;
                }
            }
        }
    }

    .logo {
        @media screen and (max-width: 768px) {
            width: auto;
            height: 25px;
        }
    }
}
</style>

<template>
    <header class="fixed z-50 w-screen transition duration-300 delay-200" :class="{scrollup: sticky, 'delay-300': sticky}">
        <div class="bg-blue usp-bar py-8 text-white">
            <div class="container">
                <div class="row">
                    <p v-if="$store.getters['isReseller']" style="line-height: 1.25rem" class="transform -translate-y-1 w-full text-center" v-html="headerData.reseller_tekst.replace(/\{{(.+?)\}}/g,  $store.getters['percentage'] )"></p>
                    <template v-else>
                        <div v-for="(usp,index) in headerData.header_usps" :key="index" class="lg:w-1/3 first:flex lg:flex items-center justify-center hidden w-full transition-opacity delay-200">
                            <span v-html="svg(usp.svg_name, 'fill-current mr-8')"></span>
                            <p style="line-height: 1.25rem" class="transform -translate-y-1" v-html="usp.description"></p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="md:pt-32 md:pb-24 py-16 bg-white border-b border-gray-300">
            <div class="container">
                <div class="flex items-center justify-center">
                    <div class="flex items-center flex-1 mr-auto">
                        <menu-toggle class="flex items-center mr-40">
                            <span v-html="svg('hamburger-static', 'fill-current text-blue mr-16 mt-2 ')"></span>
                            <span class="text-dark md:inline hidden font-bold" v-html="headerData.menu_label"></span>
                        </menu-toggle>
                        <a href="/producten" class="lg:flex items-center hidden">
                            <span v-html="svg('grid', 'fill-current text-blue mr-16 mt-2 ')"></span>
                            <span class="text-dark font-bold" v-html="headerData.products_label"></span>
                        </a>
                    </div>
                    <a href="/"><img class="logo" src="/svg/induline.svg" alt="Induline"></a>
                    <div class="flex items-center justify-end flex-1 ml-auto">
                        <a href="/contact" class="text-blue md:inline-block hidden mr-32">
                            <span v-html="svg('mail', 'fill-current ')"></span>
                        </a>
                        <search-bar class="mr-16" :placeholder="headerData.search_placeholder">
                            <div class="text-blue md:inline-block hidden mr-16">
                                <span v-html="svg('search', 'fill-current ')"></span>
                            </div>
                        </search-bar>
                        <shopping-basket-counter href="/winkelmandje" class="text-blue">
                            <span v-html="svg('shopping-cart', 'fill-current ')"></span>
                        </shopping-basket-counter>
                    </div>
                </div>
            </div>
        </div>
        <div class="lg:flex items-center justify-center hidden py-16 bg-white border-b border-gray-300">
            <slot></slot>
        </div>
    </header>
</template>

<script>
export default {
    name: "Ui.StickyHeader",

    props: {
        headerData: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            sticky: false,
        };
    },

    mounted() {
        const self = this;

        let last_known_scroll_position = 0;
        let ticking = false;
        let body = document.body,
            html = document.documentElement;

        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

        window.addEventListener('scroll', function (e) {
            last_known_scroll_position = window.scrollY;

            let height = Math.max(body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight);

            if (!ticking) {
                window.requestAnimationFrame(function () {
                    if (last_known_scroll_position > (vh / 100 * 60) && height > vh) {
                        self.sticky = true;
                    } else {
                        self.sticky = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });
    },
}
</script>